export * from './ns-adp-add/ns-adp-add.js';
export * from './ns-add-to-bag/ns-add-to-bag.js';
export * from './ns-content-accordion/ns-content-accordion.js';
export * from './ns-currency/ns-currency.js';
export * from './ns-mini-cart/ns-mini-cart.js';
export * from './ns-product/ns-product.js';
export * from './ns-product-bundle/ns-product-bundle.js';
export * from './ns-personal-offer-landing/ns-personal-offer-landing.js';
export * from './ns-product-small/ns-product-small.js';
export * from './ns-product-basic/ns-product-basic.js';
export * from './ns-product-action/ns-product-action.js';
export * from './ns-product-variant-selector/ns-product-variant-selector.js';
export * from './ns-product-variant-selector-modal/ns-product-variant-selector-modal.js';
export * from './ns-stripe-donation/ns-stripe-donation.js';
export * from './ns-variant-details/ns-variant-details.js';
export * from './ns-waiting-room/ns-waiting-room.js';

// M4 Teams Added Components
export * from './ns-featured-products/ns-featured-products.js';
export * from './ns-storefront-featured-products/ns-storefront-featured-products';
export * from './ns-billing/ns-billing.js';
export * from './ns-cc-info/ns-cc-info.js';
export * from './ns-adp-product/ns-adp-product.js';
export * from './ns-line-item/ns-line-item.js';
export * from './ns-shipping/ns-shipping.js';
export * from './ns-shipping-card/ns-shipping-card.js';
export * from './ns-shipping-info/ns-shipping-info.js';
export * from './ns-orders/ns-orders.js';
export * from './ns-scan-cards/ns-scan-cards.js';
export * from './ns-scan-card/ns-scan-card.js';
export * from './ns-adp-loyalty/ns-adp-loyalty.js';
export * from './ns-adp-wrapper/ns-adp-wrapper.js';
export * from './ns-adp-cart/ns-adp-cart.js';
export * from './ns-event-promo/ns-event-promo.js';
export * from './ns-event-banner/ns-event-banner.js';

export * from './market-banner-uploader/market-banner-uploader';

import Vue from 'vue';
import nsProductVariantSelectorVue from './ns-product-variant-selector-vue/ns-product-variant-selector-vue.vue';
import nsProductDetailDrawer from './ns-product-detail-drawer/ns-product-detail-drawer.vue';

// Add vue components in this object to get registered and exported in aem bundle
const Components = {
  nsProductVariantSelectorVue,
  nsProductDetailDrawer
};

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name]);
});
